module.exports = __webpack_public_path__ + "img/web.1310d1bf.jpg";